import { Lang } from '../../../shared/typography';
import { GoodsTypeId } from '../../../features/Product/type';

export type UpCs = {
  discounted_price: number;
  discounted_price_en: number;
  discounted_price_jp: number;
  original_quantity: number;
  order_process_id: string;
};

type ItemOrderUpC = {
  n_info: {
    name: string;
  };
  order_process_id: string;
  _: {
    up_c_ss: UpCs[];
  };
};

type ProjectionPayment = {
  pg_provider: 'paypal' | 'eximbay' | 'html5_inicis' | 'naverpay';
  imp_uid: string;
};

type ShippingOrder = {
  _: {
    item_order_up_cs: ItemOrderUpC[];
    projection_payments: ProjectionPayment[];
  };
  shipping_price: number;
  additional_shipping_price: number;
  refund_shipping_price: number;
  refund_additional_shipping_price: number;
};

type StoreOrder = {
  _: {
    group_by_shipping_orders: { shipping_orders: ShippingOrder[] }[];
  };
};

export interface ResponseImpt {
  cancel_amount: number;
  pg_provider: string;
  card_name: string;
  apply_num: number;
  card_number: number;
  card_type: number;
  card_quota: number;
  paid_at: number;
  cancelled_at: number;
}

export interface CustomerOrder {
  id: string;
  lang: Lang;
  paid_at: string;
  orderer_name: string;
  _: {
    store_orders: StoreOrder[];
  };
  impt: ResponseImpt;
}

export const ReceiptViewerType = {
  PURCHASE: 'PURCHASE',
  CARD: 'CARD',
  CASH: 'CASH',
} as const;

export interface ReceiptOption {
  price: string;
  goods_type_id: GoodsTypeId;
  name: string;
  up_c_id: string;
}
